var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [_c("pc-header"), _vm._m(0), _vm._m(1), _c("pc-footer")], 1)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-wrap" }, [
      _c("img", {
        attrs: { src: require("@/assets/images/news/news-head-bg.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-wrap" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v("支付行业必看知识，中国支付清算体系图")
      ]),
      _c("div", { staticClass: "time" }, [_vm._v("2016-08-16 15:36")]),
      _c("article", { staticClass: "article", attrs: { id: "mp-editor" } }, [
        _c(
          "p",
          {
            staticStyle: { display: "none" },
            attrs: { "data-role": "original-title" }
          },
          [_vm._v("原标题：支付行业必看知识，中国支付清算体系图")]
        ),
        _c("p", [
          _c("span", [
            _vm._v(
              "近几年支付行业的水涨船高大家都有目共睹，于是涌入这块新大陆深深耕耘着的人数也越来越多。不过和传统行业有所不同的是，支付行业对专业性的要求有一定的高度，想必这点很多新加入的朋友们也都能够体会。今天这篇文章所讲述，就是在支付行业中比较基础同时也是必须了解的一些知识。"
            )
          ])
        ]),
        _c("p", [
          _c("span", [
            _c("strong", [
              _vm._v("首先我们要了解的是，支付行业究竟有哪些机构参与。")
            ])
          ])
        ]),
        _c("p", [_c("span", [_vm._v("一：中国人民银行")])]),
        _c("p", [
          _c("span", [
            _vm._v(
              "又称央妈，支付领域的王者兼创造者，发布各项政策规范的存在。央行并不涉及支付方面的具体业务，更多时候以一个管理者的身份坐镇市场，作为支付行业的一员只需要牢记央妈是最强大的就足够了，她说什么就是什么。"
            )
          ])
        ]),
        _c("p", [_c("span", [_vm._v("二：中国银联")])]),
        _c("p", [
          _c("span", [
            _vm._v(
              "银联的来历可是说来话长了，简单的说是目前中国唯一的清算组织机构，银行间跨行的资金清算全部都要通过它来实现，本质上是协议组织。"
            )
          ])
        ]),
        _c("p", [
          _c("span", [
            _vm._v(
              "一直以来被人们称为央行的亲儿子，台面上不属于国企事业单位，但是却和国企有着千丝万缕的微妙关系，在业务方面，银联主要做的就是线上和线下银行间清算，打个比方，在线上银联在线业务类似于支付宝和微信，但战斗力远远不及，而在线下的传统pos市场则是一家独大，同时还兼任线下传统pos市场的管理者一职。"
            )
          ])
        ]),
        _c("p", [
          _c("span", [
            _vm._v(
              "不过如今国内的大环境远非当年可比，随着接下来被炒的纷纷扰扰的网联粉墨登场，未来很长一段时间内银联的日子可能不好过。"
            )
          ])
        ]),
        _c("p", [
          _c("span", [_vm._v("需要注意的是，银联和银联商务是两码事。")])
        ]),
        _c("p", [_c("span", [_vm._v("三：第三方支付机构")])]),
        _c("p", [
          _c("span", [
            _vm._v(
              "官方解释：指具备实力和信誉保障的第三方企业和国内外的各大银行签约，为买方和卖方提供的信用增强。在银行的直接支付环节中增加一中介，在通过第三方支付平台交易时，买方选购商品，将款项不直接打给卖方而是付给中介，中介通知卖家发货；买方收到商品后，通知付款，中介将款项转至卖家账户。"
            )
          ])
        ]),
        _c("p", [
          _c("span", [
            _vm._v(
              "举几个例子，支付宝、财付通（微信支付）、拉卡拉、银联商务、快钱等等这些耳熟能详的名字都属于第三方支付机构，他们提供第三方的支付结算的交易平台。"
            )
          ])
        ]),
        _c("p", [
          _c("span", [
            _vm._v(
              "正规的第三方支付机构必须拥有央行的认可资质，也就是必须获得央行颁发的支付业务许可证才可以开展业务。支付业务许可证的类型一般为：银行卡收单，互联网支付，预付费卡发行。其他如电话支付、数字电视支付等等基本可以忽略。"
            )
          ])
        ]),
        _c("p", [
          _c("span", [
            _vm._v(
              "当然，拿到支付牌照的企业也并非就可以安枕无忧，一般情况下央行视市场情况和企业的经营情况每2-5年审核一次，对于严重违规的会收回支付业务许可证，对于经营不擅的会邀约谈话要求其与有实力的公司进行股权置换或其他形式的合作，目前市面上拥有267家各类型的支付企业。"
            )
          ])
        ]),
        _c("p", [
          _c("span", [
            _vm._v(
              "以上是在支付行业当下比较重要的几个组成板块，接下来我们了解下中国支付清算体系的具体流程。"
            )
          ])
        ]),
        _c("p", [_c("span", [_c("strong", [_vm._v("1、中国支付清算体系")])])]),
        _c("p", [
          _c("span", [
            _c("strong", [_vm._v("先看一下《中国支付清算系统总体架构图》")])
          ])
        ]),
        _c("p", [
          _c("img", {
            attrs: {
              src:
                "http://img.mp.itc.cn/upload/20160816/dd1281205631485e9c7a8f6e0c298930_th.jpg",
              alt: ""
            }
          })
        ]),
        _c("p", [
          _c("span", [
            _vm._v(
              "备注，图中“中央银行支付清算系统”部分是一代的，二代增加了网上支付跨行清算系统（超级网银）。"
            )
          ])
        ]),
        _c("p", [_c("span", [_vm._v("从这张图可以看出来：")])]),
        _c("p", [
          _c("span", [
            _c("strong", [
              _vm._v("CNAPS 2代（中国现代化支付系统二代）主要包括：")
            ])
          ])
        ]),
        _c("p", [_c("span", [_vm._v("a、中央银行支付清算系统：")])]),
        _c("p", [
          _c("span", [
            _vm._v(
              "大额实时支付系统、小额批量支付系统、同城票据清算系统、境内外币支付系统、全国支票影像交换系统、网上支付跨行清算系统（超级网银）"
            )
          ])
        ]),
        _c("p", [_c("span", [_vm._v("b、第三方服务组织支付清算系统：")])]),
        _c("p", [
          _c("span", [
            _vm._v(
              "银行卡跨行支付系统（中国银联银行卡跨行交易系统）、集中代收付中心业务处理系统、城市商业银行汇票业务处理系统、农信银资金结算中心业务处理系统、其他第三方支付组织业务处理系统。"
            )
          ])
        ]),
        _c("p", [_c("span", [_vm._v("c、银行业金融机构行内支付系统")])]),
        _c("p", [_c("span", [_vm._v("d、金融市场支付清算系统")])]),
        _c("p", [
          _c("span", [
            _vm._v(
              "而中国银联银行卡跨行支付系统本身只局限于银行卡跨行支付清算上。因此可以说：中国银联银行卡跨行支付系统（CUPS）只是中国现代化支付系统（CNAPS）的一个子系统。中国现代化支付系统的主要参与者"
            )
          ])
        ]),
        _c("p", [_c("span", [_vm._v("a、直接参与者：")])]),
        _c("p", [
          _c("span", [
            _vm._v(
              "人民银行地市以上中心支行（库）、在人民银行开设清算账户的银行和非银行金融机构"
            ),
            _c("span", [_vm._v("与城市处理中心CCPC直接连接")])
          ])
        ]),
        _c("p", [_c("span", [_vm._v("b、间接参与者：")])]),
        _c("p", [
          _c("span", [
            _vm._v(
              "人民银行县（市）支行（库）、未在人民银行开设清算账户而委托直接参与者办理资金清算的银行和经人民银行批准经营支付结算业务的非银行金融机构。"
            )
          ])
        ]),
        _c("p", [
          _c("span", [
            _vm._v(
              "不与城市处理中心直接连接，其支付业务提交给其清算资金的直接参与者，由该直接参与者提交支付系统处理。"
            )
          ])
        ]),
        _c("p", [
          _c("span", [_vm._v("间接参与者的典型例子是第三方支付公司。")])
        ]),
        _c("p", [_c("span", [_vm._v("c、特许参与者：")])]),
        _c("p", [
          _c("span", [
            _vm._v("经中国人民银行批准通过支付系统办理特定业务的机构。")
          ])
        ]),
        _c("p", [
          _c("span", [
            _vm._v("在人民银行当地分支行开设特许账户，与当地城市处理中心连接"),
            _c("span", [_vm._v("特许参与者的典型代表为银联")])
          ])
        ]),
        _c("p", [_c("span", [_c("strong", [_vm._v("2、银联清算体系")])])]),
        _c("p", [_c("span", [_c("strong", [_vm._v("1、银联清算方式")])])]),
        _c("p", [
          _c("span", [_vm._v("银联的支付清算包括跨行清算和收单清算。")])
        ]),
        _c("p", [
          _c("span", [_vm._v("跨行清算是针对收单机构和发卡机构的清算。")])
        ]),
        _c("p", [
          _c("span", [
            _vm._v("收单清算是代替收单机构针对商户和收单专业化服务机构的清算。")
          ])
        ]),
        _c("p", [_c("span", [_c("strong", [_vm._v("2、银联清算的环节")])])]),
        _c("p", [
          _c("span", [_vm._v("银联的支付清算包括淸分和资金划拨两个重要环节。")])
        ]),
        _c("p", [
          _c("span", [
            _vm._v(
              "淸分是指对交易日志中记录的成功交易，逐笔计算交易本金及交易费用（手续费、分润等），然后按清算对象汇总轧差形成应收或应付金额。简言之，就是搞清楚今天应该向谁要多少钱？应该给谁多少钱？"
            )
          ])
        ]),
        _c("p", [
          _c("span", [
            _vm._v(
              "资金划拨是指通过特定的渠道和方式，完成应收应付资金的转移。简言之，就是明确通过何种渠道，拿回应收款、付出应付款。"
            )
          ])
        ]),
        _c("p", [
          _c("span", [
            _vm._v(
              "其中：清分是在银联清算系统内部完成的。而资金划拨是银联通过央行的大小额支付清算系统或同城票据交换系统完成的。"
            )
          ])
        ]),
        _c("p", [
          _c("span", [
            _c("strong", [
              _vm._v("3、银联清算系统与央行大小额支付清算系统的关系")
            ])
          ])
        ]),
        _c("p", [
          _c("span", [
            _vm._v(
              "无论是跨行清算还是收单清算，银联都是作为一个特许参与者，加入大小额支付清算系统，完成银行卡交换业务的资金划拨。"
            )
          ])
        ]),
        _c("p", [
          _c("span", [
            _vm._v(
              "银联通过大额支付系统，实现与境内成员机构清算账户之间的双向资金转移，此部分对应银联清算方式的跨行清算。"
            )
          ])
        ]),
        _c("p", [
          _c("span", [
            _vm._v(
              "银联通过小额支付系统和当地的票据交换系统，实现与境内第三方机构和商户之间的单向资金转移，此部分对应银联清算方式的收单清算。"
            )
          ])
        ]),
        _c("p", [
          _c("span", [
            _vm._v(
              "在大额支付清算系统中，银联享有比商业银行更大的特权，因为银联可以借记或贷记对方的账户，商业银行只能贷记对方的账户。在大额支付清算系统中还享有借记特权的只有国债登记公司，而且其借记操作还需有国债作抵押。"
            )
          ])
        ]),
        _c("p", [
          _c("span", [
            _c("strong", [_vm._v("4、从资金流及信息流角度看银联清算业务")])
          ])
        ]),
        _c("p", [
          _c("span", [
            _vm._v(
              "为更好理解银联清算系统与央行大小额支付系统的关系，这里从资金流及信息流角度看一下银联清算业务。"
            )
          ])
        ]),
        _c("p", [_c("span", [_vm._v("4.1、清算账户 VS. 结算账户")])]),
        _c("p", [
          _c("span", [
            _vm._v(
              "银联境内清算的清算账户均开立在人民银行，跨境业务的清算账户开立在代理清算银行（中行和汇丰）。"
            )
          ])
        ]),
        _c("p", [
          _c("span", [
            _vm._v(
              "境内成员机构的清算账户均开立在人民银行。银行一般在人民银行开立有准备金账户和备付金账户，一般使用其备付金账户用于和银联的清算。"
            )
          ])
        ]),
        _c("p", [
          _c("span", [
            _vm._v("境内商户和第三方机构的结算账户均开立在商业银行。")
          ])
        ]),
        _c("p", [
          _c("span", [_vm._v("4.2、银行卡收单（银联直连）资金流及信息流")])
        ]),
        _c("p", [
          _c("span", [
            _vm._v("1）用户在收单机构或收单行的POS机上刷卡消费。（信息流）")
          ])
        ]),
        _c("p", [
          _c("span", [
            _vm._v("2）收单机构或收单行将消费报文发送给银联。（信息流）")
          ])
        ]),
        _c("p", [
          _c("span", [
            _vm._v(
              "3）银联交易系统记录交易数据，将消费报文给发卡行。（信息流）"
            )
          ])
        ]),
        _c("p", [
          _c("span", [
            _vm._v(
              "4）发卡行从消费者卡中实时扣费，完成实时结算，并回复报文给银联。（资金流）"
            )
          ])
        ]),
        _c("p", [
          _c("span", [
            _vm._v(
              "5）银联更新交易数据，回复报文给收单机构或收单行。（信息流）"
            )
          ])
        ]),
        _c("p", [
          _c("span", [_vm._v("6）银联在其清算系统完成清分。（信息流）")])
        ]),
        _c("p", [
          _c("span", [
            _vm._v(
              "7）银联通过大额支付系统，完成收单行与发卡行清算账户的资金划拨（跨行清算）（资金流）。"
            )
          ])
        ]),
        _c("p", [
          _c("span", [
            _vm._v(
              "8）银联通过小额支付系统或当地票据交换系统，完成第三方收单机构和商户结算账户的资金划拨（收单清算）（资金流）。"
            )
          ])
        ]),
        _c("p", [_c("span", [_c("strong", [_vm._v("从此处可以看出：")])])]),
        _c("p", [
          _c("span", [
            _vm._v(
              "即便在大额支付系统和小额支付关闭情况下（例如春节升级），并不影响用户通过POS及或ATM（支持跨行）的跨行刷卡交易（只涉及信息流流转）。涉及实际资金流转的资金划拨过程是可以延迟进行。但假如是通过银行网银跨行转账，由于需要通过央行的大额、小额支付或网上支付跨行清算系统，在央行系统升级的情况下是无法进行的。"
            )
          ])
        ]),
        _c("p", [
          _c("span", [
            _vm._v(
              "这也是 为什么人行跨行支付 (CNAPS) 放假需要停运，银联 ATM 跨行转账不受影响。"
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }